import { BoothCard, BoothButton } from '@photobooth/ui';
import type { LocalProduct } from '../../../lib/db/schema';

interface ProductCardProps {
  product: LocalProduct;
  onSelect: (product: LocalProduct) => void;
}

export function ProductCard({ product, onSelect }: ProductCardProps) {
  const hasDiscount = product.originalPrice > product.price;
  const discountPercent = hasDiscount
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  return (
    <BoothCard className="relative overflow-hidden hover:shadow-2xl transition-all duration-300 flex flex-col">
      {hasDiscount && (
        <div className="absolute top-4 right-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
          {discountPercent}% OFF
        </div>
      )}

      {/* Fixed height content area - same for all cards */}
      <div className="p-6 h-[350px] flex flex-col">
        <h3 className="text-2xl font-bold mb-2 text-gray-800">{product.name}</h3>
        {product.description && (
          <p className="text-gray-600 mb-4 text-sm">{product.description}</p>
        )}
        <div className="space-y-2 mb-6">
          <div className="flex items-center gap-2 text-gray-700">
            <span className="text-2xl">📸</span>
            <span className="font-medium">{product.shotCount} shots</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700">
            <span className="text-2xl">🖨️</span>
            <span className="font-medium">{product.printCount} print{product.printCount > 1 ? 's' : ''}</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700">
            <span className="text-2xl">📄</span>
            <span className="font-medium capitalize">{product.paperType.replace('_', ' ')}</span>
          </div>
        </div>
        <div>
          {hasDiscount ? (
            <div className="space-y-1">
              <div className="text-gray-400 line-through text-lg">
                Rp {product.originalPrice.toLocaleString('id-ID')}
              </div>
              <div className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
                Rp {product.price.toLocaleString('id-ID')}
              </div>
            </div>
          ) : (
            <div className="text-3xl font-bold text-gray-800">
              Rp {product.price.toLocaleString('id-ID')}
            </div>
          )}
        </div>
      </div>

      {/* Button always at bottom */}
      <div className="p-6 pt-0">
        <BoothButton
          onClick={() => onSelect(product)}
          className="w-full"
          size="lg"
        >
          Select Package
        </BoothButton>
      </div>
    </BoothCard>
  );
}
